import { Helmet } from "react-helmet-async";

const SITE = "https://www.vishmitravels.com";

export default function Seo({ title, description, path = "/", image, type = "website" }) {
  const url = `${SITE}${path === "/" ? "" : path}`;
  const fullTitle = title?.includes("Vishmi") ? title : `${title} | Vishmi Travels`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}

export function JsonLd({ data }) {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
